import { LuX } from 'react-icons/lu';
import styles from './Drawer.module.css';

export default function Drawer({ isOpen, title, onClose, footer, children }) {
  if (!isOpen) return null;
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.drawer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <p className={styles.title}>{title}</p>
          <button className={styles.closeBtn} onClick={onClose}>
            <LuX size={18} />
          </button>
        </div>
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
